export default "__VITE_PUBLIC_ASSET__027a2ec4__"